export enum AppLogType {
  EMAIL = 'EMAIL',
  SES_EVENT = 'SES_EVENT',
}

export enum AppLogStatus {
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
}

export const AppLogTypeName: Record<AppLogType, string> = {
  [AppLogType.EMAIL]: 'Email',
  [AppLogType.SES_EVENT]: 'SES Event',
}
